import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserTooltipInfoFragmentDoc } from '../../fragment/generated/UserTooltipInfo';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserTooltipQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type UserTooltipQuery = { user?: { status: Types.UserStatusEnum, createdAt: string, id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };

export type UserTooltipFromCacheQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type UserTooltipFromCacheQuery = { user?: { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };


export const UserTooltipDocument = /*#__PURE__*/ gql`
    query userTooltip($filters: UserFilters!) {
  user(filters: $filters) {
    ...UserTooltipInfo
  }
}
    ${UserTooltipInfoFragmentDoc}
${UserFragmentDoc}`;

export function useUserTooltipQuery(options: Omit<Urql.UseQueryArgs<UserTooltipQueryVariables>, 'query'>) {
  return Urql.useQuery<UserTooltipQuery, UserTooltipQueryVariables>({ query: UserTooltipDocument, ...options });
};
export const UserTooltipFromCacheDocument = /*#__PURE__*/ gql`
    query userTooltipFromCache($filters: UserFilters!) {
  user(filters: $filters) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUserTooltipFromCacheQuery(options: Omit<Urql.UseQueryArgs<UserTooltipFromCacheQueryVariables>, 'query'>) {
  return Urql.useQuery<UserTooltipFromCacheQuery, UserTooltipFromCacheQueryVariables>({ query: UserTooltipFromCacheDocument, ...options });
};